/*
 * @description: 上传图片的组件封装
 * @author:Jsj
 * @Compile：2021-01-28 09：00
 * @update:jsj(2021-01-29 18：00)
 * @memo:append-to-body 属性是用来提高dialog的层级 此坑十分的坑
 */

import Material from '@/components/content/material/material.vue'

export default {
  name: 'ImgUpload',
  components: {
    Material
  },
  props: {
    // 组件调用类型
    imgUploadType: {
      type: Number,
      default() {
        return 0
      }
    },
    // 单选图片的显示路径
    imgPath: {
      type: String,
      default() {
        return ''
      }
    },
    // 多选图片的显示路径
    imgPathArry: {
      type: Array,
      default() {
        return ['']
      }
    },
    //隐藏预览功能
    noPreview: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data() {
    return {
      imglistDialog: false,
      dialogVisible: false,
      imageUrl: '' // 图片预览路径
    }
  },
  watch: {},

  mounted() {
    this.to_Load() // 进入此页面先加载
  },
  methods: {
    /**
     * 打开图片列表
     */
    open_img_list() {
      if (this.imgUploadType == '1') {
        this.imglistDialog = true
      } else if (this.imgUploadType == '2') {
        if (this.imgPathArry.length < 10) {
          this.imglistDialog = true
        }
      }
    },

    /**
     * 保存当前选中的图片
     */
    submit_checked_img(arry) {
      if (arry.length > 0) {
        this.$emit('submit_checked_img', arry)
        this.imglistDialog = false
      } else {
        this.$message.error('请选择图片！')
      }
    },

    /**
     * 取消选择图片，关闭模态框
     */
    cancel_checked_img() {
      this.imglistDialog = false
    },


    /**
     * 删除但前选中的图片
     * 给父组件传递一个空的图片
     */
    delete_img(index) {
      if (this.imgUploadType == '1') {
        this.imgPath = ''
        let arry = [{img_path_url: '', img_url: ''}]
        this.$emit('submit_checked_img', arry)
      } else if (this.imgUploadType == '2') {
        this.$emit('mult_dalete_checked_img', index)
      }

    },

    /**
     * 预览图片按钮
     * 将这个图片的的路径传递给弹窗的img标签用来显示
     */
    view_img(imgPath) {
      this.imageUrl = imgPath
      this.dialogVisible = true
    },

    /**
     * 进入此页面进行加载
     */
    to_Load() {
      console.log(this.imgPathArry)
    }
  }
}
